module.exports = __webpack_public_path__ + "img/downloads_flipbook.eca8ee39.jpg";